import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactTable from "../../AppComponent/Table";
import _ from "lodash";
import DeleteImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-05.svg";
import {
  GetEmployeeBulkUploadDataRequest,
  GetSheetBulkUploadDataSucess,
  SheetBulkUploadSucess,
  setSelectedUploadTab,
} from "../../../Redux/Slice";
import { FaDownload } from "react-icons/fa";
import EmployeeBulkuploadPopup from "./EmployeeBulkuploadPopup";
import DenaveNewBulkUpload from "./DenaveNewBulkUpload";
import { useNavigate } from "react-router-dom";
import yesIcon from "../../../Assets/yes.png";
import errorIcon from "../../../Assets/error.png";
import fileDownloadIcon from "../../../Assets/fileDownload.png";

const EmployeeBulkupload = () => {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive,
  );
  const dispatch = useDispatch();
  const [sno, setsno] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  const [search, setsearch] = useState("");
  const [DeleteID, setDeleteId] = useState();
  const [DeletePopup, setDeletePopup] = useState(false);
  const [pageSize, setPageSize] = useState(20);
  const navigate = useNavigate();

  const selectedTab = useSelector(
    (state) => state.SideBarFiles.selectedUploadTab
  );

  const handleTabChange = (tabName) => {
    dispatch(setSelectedUploadTab(tabName));
  };

  const { employeeBulkUploaddata, totalCount } = useSelector(
    (state) => state.employeeBulkUploadGetData,
  );

  console.log(employeeBulkUploaddata, "kdlksakldalkdlkalk");
  const [bulkUploadPopup, setBulkUploadPopup] = useState(false);

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };
  const pageindex = (arg) => {
    //  console.log(arg, "args");
    setdtPageindex(arg);
  };

  const debouncedSearch = useMemo(
    () =>
      _.debounce((e) => {
        // console.log("Searching for:", e);

        setsearch(e);
      }, 500),
    [],
  );
  function tochange(e) {
    setdtPageindex(1);
    // setsearch(e);
    debouncedSearch(e);
  }

  const handleNext = (next) => {
    setdtPageindex(next + 1);
  };

  const GotoEnteredPage = (gotopage) => {
    setdtPageindex(gotopage);
  };

  const handleDownload = (url) => {
    if (!url) return;

    window.open(url, "_blank");
  };

  // useEffect(() => {
  //   // dispatch(setSelectedUploadTab("Denave Bulkupload"));
  //   if (selectedTab === "Denave Bulkupload") {
  //     const payload = {
  //       page_size: 20,
  //       page: 1,
  //       search: "",
  //     };
  //     dispatch(GetEmployeeBulkUploadDataRequest(payload));
  //   }
  // }, []);
  useEffect(() => {
    if (selectedTab === "Denave Bulkupload") {
      const payload = {
        page_size: 20,
        page: dtpageindex,
        search: search,
      };
      dispatch(GetEmployeeBulkUploadDataRequest(payload));
    }
  }, [dtpageindex, selectedTab, search]);
  // useEffect(() => {
  //   if (selectedTab === "Denave Bulkupload") {
  //     const interval = setInterval(() => {
  //       dispatch(
  //         GetEmployeeBulkUploadDataRequest({
  //           page_size: 20,
  //           page: dtpageindex,
  //           search: search,
  //         }),
  //       );
  //     }, 10000);
  //     return () => clearInterval(interval);
  //   }
  // }, [dispatch, dtpageindex, selectedTab, search]);
  const handlePrevious = (previous) => {
    if (previous != 0) {
      setdtPageindex(previous);
    }
  };

  const columns = useMemo(
    () => [
      {
        Header: "S.NO",
        accessor: "",
        Cell: (row) => {
          console.log(row.row);
          console.log(sno);
          return <p>{Number(sno + row.row.index + 1)}</p>;
        },
      },

      {
        Header: "Employee Name",
        accessor: "employee_name",
        Cell: (row) => {
          return (
            <>
              <span className="wrap-cell" style={{ minWidth: "150px", maxWidth: "200px" }}>
                {row.row.original?.employee_name}
              </span>
            </>
          );
        },
      },
      {
        Header: "Employeement Type",
        accessor: "employee_type",
        Cell: (row) => {
          const type = row.row.original?.employee_type;
          return (
            <>
              <span>
                {type == "0"
                  ? "Permanent"
                  : type == "1"
                    ? "Contractual"
                    : type == "2"
                      ? "Consultant"
                      : type == "3"
                        ? "Freelancer"
                        : type == "4"
                          ? "Intern"
                          : type == "5"
                            ? "Apprentice"
                            : "-"}
              </span>
            </>
          );
        },
      },
      {
        Header: "Phone Number",
        accessor: "phone_number",
        Cell: (row) => {
          return (
            <>
              <span>{row.row.original?.phone_number}</span>
            </>
          );
        },
      },
      {
        Header: "Email",
        accessor: "email",
        Cell: (row) => {
          return (
            <>
              <span>{row.row.original?.email}</span>
            </>
          );
        },
      },

      {
        Header: "Aadhar Number",
        accessor: "aadhar_number",
        Cell: (row) => {
          return (
            <>
              <span>{row.row.original?.aadhar_number}</span>
            </>
          );
        },
      },
      {
        Header: "Pan Number",
        accessor: "pan_number",
        Cell: (row) => {
          return (
            <>
              <span>{row.row.original?.pan_number}</span>
            </>
          );
        },
      },

      {
        Header: "Aadhar Pan Link Status",
        accessor: "aadhar_pan_linked",
        Cell: (row) => {
          return (
            <>
              <img
                src={row.row.original?.aadhar_pan_linked ? yesIcon : errorIcon}
                alt={row.row.original?.aadhar_pan_linked ? "Yes" : "No"}
                style={{ width: "30px", height: "30px" }}
              />
            </>
          );
        },
      },
      {
        Header: "Pan Verified",
        accessor: "pan_verified",
        Cell: (row) => {
          return (
            <>
              <img
                src={row.row.original?.pan_verified ? yesIcon : errorIcon}
                alt={row.row.original?.pan_verified ? "Yes" : "No"}
                style={{ width: "30px", height: "30px" }}
              />
            </>
          );
        },
      },
      {
        Header: "Gst Pan Link Status",
        accessor: "gst_pan_linked",
        Cell: (row) => {
          return (
            <>
              <img
                src={row.row.original?.gst_pan_linked ? yesIcon : errorIcon}
                alt={row.row.original?.gst_pan_linked ? "Yes" : "No"}
                style={{ width: "30px", height: "30px" }}
              />
            </>
          );
        },
      },
      {
        Header: "Project Name",
        accessor: "project",
        Cell: (row) => {
          return (
            <>
              <span className="wrap-cell" style={{ minWidth: "160px", maxWidth: "240px" }}>
                {row.row.original?.project}
              </span>
            </>
          );
        },
      },
      {
        Header: "Designation",
        accessor: "designation",
        Cell: (row) => {
          return (
            <>
              <span className="wrap-cell" style={{ minWidth: "140px", maxWidth: "180px" }}>
                {row.row.original?.designation}
              </span>
            </>
          );
        },
      },
      {
        Header: "Date Of Birth",
        accessor: "date_of_birth",
        Cell: (row) => {
          return (
            <>
              <span>{row.row.original?.date_of_birth}</span>
            </>
          );
        },
      },
      {
        Header: "Date Of Joining",
        accessor: "date_of_joining",
        Cell: (row) => {
          return (
            <>
              <span>{row.row.original?.date_of_joining}</span>
            </>
          );
        },
      },
      {
        Header: "HRA Salary",
        accessor: "hra_salary",
        Cell: (row) => {
          return (
            <>
              <span>{row.row.original?.hra_salary}</span>
            </>
          );
        },
      },
      {
        Header: "Accident Insurance",
        accessor: "accident_insurance",
        Cell: (row) => {
          return (
            <>
              <span>{row.row.original?.accident_insurance}</span>
            </>
          );
        },
      },
      {
        Header: "Medical Insurance",
        accessor: "medical_insurance",
        Cell: (row) => {
          return (
            <>
              <span>{row.row.original?.medical_insurance}</span>
            </>
          );
        },
      },
      {
        Header: "Marital Status",
        accessor: "marital_status",
        Cell: (row) => {
          return (
            <>
              <span>{row.row.original?.marital_status}</span>
            </>
          );
        },
      },
      {
        Header: "Role",
        accessor: "role",
        Cell: (row) => {
          return (
            <>
              <span>{row.row.original?.role}</span>
            </>
          );
        },
      },
      {
        Header: "State",
        accessor: "state",
        Cell: (row) => {
          return (
            <>
              <span>{row.row.original?.state}</span>
            </>
          );
        },
      },
      {
        Header: "Location",
        accessor: "location",
        Cell: (row) => {
          return (
            <>
              <span className="wrap-cell" style={{ minWidth: "140px", maxWidth: "200px" }}>
                {row.row.original?.location}
              </span>
            </>
          );
        },
      },

      {
        Header: "Created Date",
        accessor: "",
        Cell: (row) => {
          const dateString = row.row.original.created_at;
          const dateObject = new Date(dateString);
          const hours = dateObject.getHours();
          const minutes = dateObject.getMinutes();
          const seconds = dateObject.getSeconds();
          const amOrPm = hours >= 12 ? "PM" : "AM";
          const twelveHourFormat = hours % 12 || 12;
          const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

          const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;
          return (
            <>
              <span style={{ textWrap: "nowrap" }}>
                {`${row.row.original.created_at.slice(0, 10) +
                  "  " +
                  formattedTime
                  }`}
              </span>
            </>
          );
        },
      },

      {
        Header: "Offer Letter",
        accessor: "offer_letter",
        Cell: (row) => {
          const url = row.row.original?.offer_letter;

          return url ? (
            <span
              onClick={() => handleDownload(url)}
              title="Download Uploaded Sheet"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
                cursor: "pointer",
                border: "1px solid green",
                backgroundColor: "green",
                padding: "3px 7px",
                color: "white",
                borderRadius: "5px",
              }}
            >
              <img
                src={fileDownloadIcon}
                alt="Download"
                style={{ width: "30px", height: "30px" }}
              />{" "}
              <span>Download</span>
            </span>
          ) : null;
        },
      },
    ],

    [employeeBulkUploaddata],
  );


  return (
    <>
      {selectedTab === "Self onboarding" ? (
        <DenaveNewBulkUpload />
      ) : (
        <div className={stateDisplay ? "outterContent" : "inner-Content"}>
          <div
            className="Header-Details ClientBranch"
            style={{
              padding: "14px 28px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "20px !important",
            }}
          >
            <div
              // className="InnerUsers col-md-6"
              class="col-sm-7 auto"
              style={{
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div style={{ display: "flex", gap: "25px", borderBottom: "1px solid #dee2e6", width: "100%" }}>
                <span
                  className="user-name mb-0"
                  style={{
                    cursor: "pointer",
                    fontSize: "18px",
                    fontWeight: selectedTab === "Denave Bulkupload" ? "600" : "400",
                    color: selectedTab === "Denave Bulkupload" ? "#f26639" : "#6b7280",
                    borderBottom: selectedTab === "Denave Bulkupload" ? "3px solid #f26639" : "3px solid transparent",
                    paddingBottom: "8px",
                    transition: "all 0.3s ease"
                  }}
                  onClick={() => handleTabChange("Denave Bulkupload")}
                >
                  Denave Bulkupload
                </span>
                <span
                  className="user-name mb-0"
                  style={{
                    cursor: "pointer",
                    fontSize: "18px",
                    fontWeight: selectedTab === "Self onboarding" ? "600" : "400",
                    color: selectedTab === "Self onboarding" ? "#f26639" : "#6b7280",
                    borderBottom: selectedTab === "Self onboarding" ? "3px solid #f26639" : "3px solid transparent",
                    paddingBottom: "8px",
                    transition: "all 0.3s ease"
                  }}
                  onClick={() => handleTabChange("Self onboarding")}
                >
                  Self onboarding
                </span>
              </div>
            </div>
            <div
              className="Add-User col-sm-5"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                justifyContent: "flex-end",
              }}
            >

              <button
                onClick={(e) => {
                  navigate("/denavebulkupload/preview");
                }}
                className="ButtonCSS"
                style={{ marginBottom: "10px" }}
              >
                Bulkupload Status
              </button>
              <button
                onClick={(e) => {
                  setBulkUploadPopup(true);
                }}
                className="ButtonCSS"
                style={{ marginBottom: "10px" }}
              >
                Bulk Upload
              </button>
            </div>
          </div>
          <div
            className="denave-bulkupload-table"
            style={{
              padding: " 0px 40px",
              marginTop: "-13px",
              marginBottom: "20px",
            }}
          >
            {/* wide table: keep cells on one line and scroll horizontally (table-responsive wrapper) */}
            <style>{`
              .denave-bulkupload-table .table-responsive { overflow-x: auto; container-type: inline-size; }
              .denave-bulkupload-table .INNERTABLE { width: max-content; min-width: 100%; }
              .denave-bulkupload-table .Dusbinbacktabls { position: sticky; left: 0; width: 100cqw; }
              .denave-bulkupload-table .table-responsive > .row { position: sticky; left: 0; width: 100cqw !important; }
              .denave-bulkupload-table .TableDesgin { min-width: 2800px; }
              .denave-bulkupload-table .TableDesgin th {
                width: auto !important;
                white-space: nowrap;
                vertical-align: middle;
                padding: 12px 14px !important;
              }
              .denave-bulkupload-table .TableDesgin td {
                white-space: nowrap;
                vertical-align: middle;
                padding: 12px 14px !important;
              }
              .denave-bulkupload-table .TableDesgin td p { margin: 0; }
              .denave-bulkupload-table .wrap-cell {
                display: inline-block;
                white-space: normal;
                word-break: break-word;
              }
            `}</style>
            <ReactTable
              data={employeeBulkUploaddata ? employeeBulkUploaddata : []}
              columns={columns}
              // totalItems={state.ReportSheetData.Total_Count}
              currentPage={currentPage}
              onChange={tochange}
              setCurrentPage={setCurrentPage}
              pagesize={pagesize}
              dtpagesize={pageSize}
              dtpageindex={dtpageindex}
              pageindex={pageindex}
              // datacount={state.ReportSheetData.Total_Count}
              // datacount={state.ReportSheetData?.Total_Count}
              totalItems={totalCount}
              datacount={totalCount}
              MakeCreate={false}
              Filter={true}
              NoFilter={true}
              search_key={true}
              searchVal={search}
              onPrevious={handlePrevious}
              onNextpage={handleNext}
              GotoEnteredPage={GotoEnteredPage}
              // value={StatusVal}
              // options={options}
              // count={count}
              // ClearState={ClearState}
              placeHold={"All"}
              setsno={setsno}
              sno={sno}
              id={"spe"}
            />
          </div>
          {bulkUploadPopup && (
            <EmployeeBulkuploadPopup setPopup={setBulkUploadPopup} />
          )}
        </div>
      )}
    </>
  );
};

export default EmployeeBulkupload;
